<template>
    <svg class="animate-spin" :class="wrapStyle" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z" stroke="currentColor" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round"/>
        <path d="M12 3C16.9706 3 21 7.02944 21 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script setup>
defineProps({
    wrapStyle: {
        type: String,
        default: 'h-6 w-6',
    },
})
</script>
